import { render, staticRenderFns } from "./packing.vue?vue&type=template&id=1faa8e18&"
import script from "./packing.vue?vue&type=script&lang=js&"
export * from "./packing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1faa8e18')) {
      api.createRecord('1faa8e18', component.options)
    } else {
      api.reload('1faa8e18', component.options)
    }
    module.hot.accept("./packing.vue?vue&type=template&id=1faa8e18&", function () {
      api.rerender('1faa8e18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/packing.vue"
export default component.exports